import { createSlice } from '@reduxjs/toolkit';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    productCount: 0,
    catalogueCount: 0,
    activeCatalogueCount: 0,
    quotationCount: 0,
    buyersCount: 0,
    fairEnquiriesCount: 0,
    shouldFetchProducts: false,
},

  reducers: {
    setShouldFetchProducts: (state, action) => {
      state.shouldFetchProducts = action.payload;
    },
    setProductCount: (state, action) => {
      state.productCount = action.payload;
    },
    setCatalogueCount: (state, action) => {
      state.catalogueCount = action.payload;
    },
    setActiveCatalogueCount: (state, action) => {
      state.activeCatalogueCount = action.payload;
    },
    setQuotationCount: (state, action) => {
      state.quotationCount = action.payload;
    },
    setBuyersCount: (state, action) => {
      state.buyersCount = action.payload;
    },
    setFairEnquiriesCount: (state, action) => {
      state.fairEnquiriesCount = action.payload;
    },

    // optional helper: set all counts at once
    setDashboardData: (state, action) => {
      return { ...state, ...action.payload };
    }
  },
});

export const {
  setShouldFetchProducts,
  setProductCount,
  setCatalogueCount,
  setActiveCatalogueCount,
  setQuotationCount,
  setBuyersCount,
  setFairEnquiriesCount,
  setDashboardData,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
